import type { StaticImageData } from "next/image";

import AUDIBLE from "@public/partners/AUDIBLE.png";
import BITVAVO from "@public/partners/BITVAVO.svg";
import COCA from "@public/partners/COCA.png";
import COINGECKO from "@public/partners/COINGECKO.png";
import FREECASH from "@public/partners/FREECASH.svg";
import GOMINING from "@public/partners/GOMINING.svg";
import HELIUM_MOBILE from "@public/partners/HELIUM_MOBILE.png";
import KRAKEN from "@public/partners/KRAKEN.svg";
import MORALIS from "@public/partners/MORALIS.svg";
import NEAR from "@public/partners/NEAR.svg";
import NEAR_AI from "@public/partners/NEAR_AI.png";
import NOOM from "@public/partners/NOOM.svg";
import PRODEGE from "@public/partners/PRODEGE.svg";
import PROPHETMARKET from "@public/partners/PROPHETMARKET.svg";
import SWEATCOIN from "@public/partners/SWEATCOIN.png";
import UPLAND from "@public/partners/UPLAND.svg";

export interface Partner {
  /**
   * Brand name. Used for the logo's alt text, and rendered as a plain
   * wordmark on the rare partner whose logo file we do not have yet.
   */
  name: string;
  /**
   * White-on-dark mark from `public/partners/`. Optional so a partner can go
   * live with the name alone: drop the file in, add it here, and the wordmark
   * becomes the logo with no other change.
   */
  logo?: StaticImageData;
  /**
   * Rendered height in px for the homepage carousel. The source marks have
   * wildly different viewBoxes and glyph-fill ratios, so a single height makes
   * some read as twice the size of others. Tune per mark. Defaults to 24.
   */
  height?: number;
}

/** Order here drives both the homepage carousel and the /partners logo grid. */
export const PARTNERS: Partner[] = [
  { name: "FreeCash", logo: FREECASH, height: 28 },
  { name: "UpLand", logo: UPLAND, height: 30 },
  { name: "GoMining", logo: GOMINING, height: 30 },
  { name: "Kraken", logo: KRAKEN, height: 26 },
  { name: "Bitvavo", logo: BITVAVO, height: 26 },
  { name: "ProphetMarket", logo: PROPHETMARKET, height: 30 },
  { name: "CoinGecko", logo: COINGECKO, height: 30 },
  { name: "Coca.xyz", logo: COCA, height: 30 },
  { name: "NEAR", logo: NEAR, height: 24 },
  { name: "Audible", logo: AUDIBLE, height: 30 },
  { name: "Prodege", logo: PRODEGE, height: 30 },
  { name: "Helium Mobile", logo: HELIUM_MOBILE, height: 40 },
  { name: "Noom", logo: NOOM, height: 26 },
  { name: "NEAR AI", logo: NEAR_AI, height: 20 },
  { name: "Sweatcoin", logo: SWEATCOIN, height: 34 },
  { name: "Moralis", logo: MORALIS, height: 34 },
];
